<template>
  <div :class="badgeType" class="tag is-rounded is-uppercase ml-5">
    {{ badgeLabel }}
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  props: {
    status: {type: String}
  },
  data() {
    return {
      tokenColors: {
        bronze: 'bronze',
        silver: 'silver',
        orange: 'orange',
        darkGrey: 'dark-grey',
        gray: 'gray',
      }
    };
  },
  computed: {
    ...mapGetters(['referralsMetaState']),
    badgeType() {
      let stages = {
        pending: this.tokenColors.gray,
        applied: this.tokenColors.bronze,
        qualified: this.tokenColors.bronze,
        shortlisted: this.tokenColors.bronze,
        interview: this.tokenColors.silver,
        offer: this.tokenColors.silver,
        hired: this.tokenColors.orange,
        dismissed: this.tokenColors.darkGrey,
        general: this.tokenColors.bronze
      };

      return stages[this.status] || stages['general'];
    },
    badgeLabel() {
      return this.status && this.referralsMetaState.statuses ? this.referralsMetaState.statuses[this.status] : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  margin-left: 5px;
}

.bronze {
  color: var(--dirty-orange);
  background-color: var(--pale-yellow);
}

.silver {
  color: var(--dark-gray);
  background-color: var(--mid-gray);
}

.dark-grey {
  color: var(--white);
  background-color: var(--dark-gray);
}

.gray {
  color: var(--white);
  background-color: var(--gray);
}

.orange {
  color: var(--orange);
  background-color: var(--pale-orange);
}
</style>
